import React, { useState, useEffect } from "react";
import { oneOfType, string, number, func } from "prop-types";
import './styles.scss';

const CellInput = ({ defaultValue, value, onChange, ...props }) => {
  const [internalValue, setInternalValue] = useState(defaultValue || '');

  useEffect(() => {
    if (value === undefined) {
      setInternalValue(defaultValue || '');
    }
  }, [defaultValue, value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (value === undefined) {
      setInternalValue(newValue);
    }
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <input 
      className="cell-input" 
      value={value !== undefined ? value : internalValue}
      onChange={handleChange}
      {...props} 
    />
  );
};

CellInput.propTypes = {
	defaultValue: oneOfType([ string, number ]),
	value: oneOfType([ string, number ]),
	onChange: func
};

export default CellInput;
